// Route shell only. Implementation lives at src/dev/preview-annual-summary.impl.tsx
// and is loaded ONLY in dev — `import.meta.env.PROD` is statically replaced
// at build time, so Rollup tree-shakes the dynamic import in production
// and no impl chunk ships. `beforeLoad` returns 404 in prod as a backstop.
import { createFileRoute, notFound, lazyRouteComponent } from "@tanstack/react-router";

export const Route = createFileRoute("/dev/preview-annual-summary")({
  beforeLoad: () => {
    if (import.meta.env.PROD) throw notFound();
  },
  component: import.meta.env.PROD
    ? () => null
    : lazyRouteComponent(() => import("@/dev/preview-annual-summary.impl")),
  head: () => ({
    meta: [{ name: "robots", content: "noindex, nofollow" }],
  }),
});
